import { render, staticRenderFns } from "./PrinciplesPlayerSetup.vue?vue&type=template&id=9a69cf64&"
import script from "./PrinciplesPlayerSetup.vue?vue&type=script&lang=js&"
export * from "./PrinciplesPlayerSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports